import { TransportOperatorService } from 'src/app/angularJS/services/transport-operator/transport-operator.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';

export class SpecialDayDialogController {
  public static $inject = [
    'transportOperatorService',
    '$mdDialog',
    '$q',
    'userService',
    'LinkBuilder',
    'QueryBuilder',
    '$translate'
  ];

  public specialDay: InterACT.Interfaces.SpecialDays.SpecialDay;
  public selectedOperator: InterACT.Interfaces.TransportOperators.TransportOperator;
  public operatorSearchText: string;
  public currentLocale: string;

  constructor(
    private transportOperatorService: TransportOperatorService,
    private $mdDialog: ng.material.IDialogService,
    private $q: ng.IQService,
    private userService: UserService,
    private linkBuilder: LinkBuilder,
    private queryBuilder: QueryBuilder,
    private $translate: ng.translate.ITranslateService
  ) {
    this.activate();
  }

  /**
   * A method that updates the operators on the special day
   */
  public updateSelected = () => {

    if (!this.selectedOperator) {
      return;
    }

    const operatorLink = this.linkBuilder.getTransportOperatorsLink(this.selectedOperator.id);
    const operatorAlreadySelected = this.specialDay.operators.some((operator) => {
      return operator.link === operatorLink;
    });

    if (operatorAlreadySelected) {
      return;
    }

    const transportOperatorLink = {
      link: operatorLink,
      name: this.selectedOperator.name[this.currentLocale]
    };

    this.specialDay.operators.push(transportOperatorLink);
    this.operatorSearchText = '';

  };

  /**
   * A method that retrieves the transport operators that satisfy the supplied search text
   * @param searchText the search text to use to locate a transport operator
   */
  public getTransportOperators = (searchText: string) => {
    const deferred = this.$q.defer();

    if (!searchText) {
      deferred.resolve([]);
    }

    const schemeLink = this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id);
    const builder = this.queryBuilder.newParam()
      .fieldIs('schemes.link', schemeLink);
    if (searchText !== '') {
      this.queryBuilder
        .and()
        .fieldContains('name.' + this.currentLocale, searchText);
    }

    this.transportOperatorService.getList(1, 1000, builder.getParam()).then((response) => {
      deferred.resolve(response.transportOperators);
    });

    return deferred.promise;
  }

  /**
   * Function which is used to complete a dialog action
   */
  public ok = () => {
    this.$mdDialog.hide(this.specialDay);
  }

  /**
   * checks the length of the operators array
   * @return boolean if here are operators
  */
  public checkOperatorLength = () => {
    if (this.specialDay.operators.length > 0) {
      return true;
    }
    return false;
  }
  /**
   * A method that is called during controller instantiation
   */
  private activate() {
    this.currentLocale = this.$translate.use();
  }
}